import type { ReactiveFormRequestHandler } from '../../adapters/reactive-form-builder.adapters';
import type {
    ReactiveFormRequestAdapter,
    ReactiveFormRequestAdapterState,
} from '../../adapters/reactive-form-request.adapter';
import { ReactiveFormSubmitAdapterExecutor } from './reactive-form-submit-adapter-executor';

export interface ReactiveFormSubmitRefreshPolicyConfiguration {
    readonly adapter: ReactiveFormRequestAdapter<unknown, unknown> | null;
    readonly adapterState: ReactiveFormRequestAdapterState;
    readonly fallbackRequest: ReactiveFormRequestHandler<unknown, void> | null;
    readonly logError?: (message: string, error: unknown) => void;
}

/**
 * Chooses the safest post-submit refresh strategy for adapter and legacy request flows.
 */
export class ReactiveFormSubmitRefreshPolicy {
    private readonly adapterExecutor = new ReactiveFormSubmitAdapterExecutor<unknown, unknown>();

    public async execute(configuration: ReactiveFormSubmitRefreshPolicyConfiguration): Promise<void> {
        if (configuration.adapter?.refresh) {
            try {
                await this.adapterExecutor.execute({
                    adapter: configuration.adapter,
                    operation: 'refresh',
                    state: configuration.adapterState,
                });
            } catch (error) {
                configuration.logError?.('ReactiveFormRequestAdapter refresh failed:', error);
            }

            return;
        }

        configuration.fallbackRequest?.safePerform();
    }
}
